import React from "react";
import { StyleSheet, View } from "react-native";
import Heading from "../../components/Heading";
import { colors } from "../../theme";

const InformationCell: React.FC<{ label: string }> = ({ label, children }) => (
  <View style={styles.informationCell}>
    <Heading size="label" style={styles.cellLabel}>
      {label}
    </Heading>
    {children}
  </View>
);

const styles = StyleSheet.create({
  informationCell: {
    marginBottom: 10,
  },
  cellLabel: {
    color: colors.darkGrey,
  },
});

export default InformationCell;
